import React from 'react';

export const Humberger: React.FC = () => {
  return (
    <>
      <svg
        width={24}
        height={25}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3645_30716)">
          <path
            d="M3 18.5H21V16.5H3V18.5ZM3 13.5H21V11.5H3V13.5ZM3 6.5V8.5H21V6.5H3Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3645_30716">
            <rect
              width={24}
              height={24}
              fill="black"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
